import PointAlarmsProvider from '../../providers/PointAlarmsProvider'

class PointAlarmService {
  async getAlgorithms () {
    return PointAlarmsProvider.getAlgorithms()
  }

  async getAlgorithmSettings (asset) {
    return PointAlarmsProvider.getAlgorithmSettings(asset)
  }

  async createAlgorithmSetting (asset, algorithmSetting) {
    return PointAlarmsProvider.createAlgorithmSetting(asset, algorithmSetting)
  }

  async updateAlgorithmSetting (asset, algorithmSetting) {
    return PointAlarmsProvider.updateAlgorithmSetting(asset, algorithmSetting)
  }

  async removeAlgorithmSetting (asset, id) {
    return PointAlarmsProvider.removeAlgorithmSetting(asset, id)
  }

  async previewBackgroundWorker (asset, algorithmSetting) {
    return PointAlarmsProvider.previewBackgroundWorker(asset, algorithmSetting)
  }

  async getHealthScore (asset, from, to, direction, days) {
    return PointAlarmsProvider.getHealthScore(asset, from, to, direction, days)
  }
}

export default new PointAlarmService()



// WEBPACK FOOTER //
// ./src/services/r8/PointAlarmsService.js